import React, {Fragment} from 'react';
import styled from 'styled-components';
import types from './types';
import extractSetting from './extractSetting';

const Label = styled.span`
  font-weight: bold;
`;

export const SettingsPreview = ({settings}) => (
  <Fragment>
    {types.map(({type, label}, i, {length}) => (
      <Fragment key={type}>
        <Label>{label}</Label>: {extractSetting(settings, type)}
        {i < length - 1 && <br />}
      </Fragment>
    ))}
  </Fragment>
);

export default SettingsPreview;
